import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// import {
//   MatProgressBarModule,
//   MatProgressSpinnerModule,
// } from "@angular/material";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LoaderComponent } from "./component/loader.component";

@NgModule({
  imports: [CommonModule, MatProgressBarModule, MatProgressSpinnerModule],
  exports: [LoaderComponent, MatProgressBarModule],
  declarations: [LoaderComponent],
})
export class LoaderModule { }
